import React from 'react';
import './ActionConfirmationPopup.css';
import {ReactComponent as LoaderIcon} from '../../images/loader-icon.svg';
export default function ActionConfirmationPopup({
  title = 'Подтверждение',
  message = 'Вы уверены, что хотите выполнить это действие?',
  confirmText = 'Подтвердить',
  cancelText = 'Отмена',
  onConfirm,
  onCancel,
  isOpen,
  className = '',
  isLoading = false,
  style = {},
}) {
  // if (!isOpen) return null;

  return (
    <div
      className={`popup-container ${className} ${isOpen ? 'show' : ''}`}
      style={style}
    >
      <div className='popup-content'>
        <h2 className='popup-title'>{title}</h2>
        <p className='popup-message'>{message}</p>
        <div className='popup-buttons'>
          <button onClick={onConfirm} className='popup-button confirm-button'>
            {isLoading ? <LoaderIcon /> : confirmText}
          </button>
          <button onClick={onCancel} className='popup-button cancel-button'>
            {cancelText}
          </button>
        </div>
      </div>
    </div>
  );
}
